// extracted by mini-css-extract-plugin
export default {"loadingContainer":"PaginationLoader__loadingContainer___C2_Rp"};